import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Roundtripcabnavimumbai() {



    const cardData = {





keyword: "Round Trip Cab Navi Mumbai",

headingDescription: "Shreesha Tours & Travels provides reliable Round Trip Cab Service in Navi Mumbai for family vacations, weekend getaways, corporate travel, business trips, pilgrimage tours, sightseeing journeys, and long-distance travel. We offer comfortable chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for return journeys with flexible travel plans. With experienced drivers, well-maintained cars, transparent pricing, doorstep pickup and drop, customized trip packages, and 24/7 customer support, we ensure a safe and comfortable round trip experience from Navi Mumbai. Whether you are planning a short holiday or a multi-day tour, Shreesha Tours & Travels provides convenient and affordable round trip cab booking services.",

topPlaces: [
  {
    title: "Navi Mumbai to Goa Round Trip",
    description: "Goa is one of India's most popular holiday destinations, famous for beautiful beaches, Portuguese churches, forts, nightlife, water sports, and luxury resorts. A round trip cab from Navi Mumbai to Goa is ideal for families, couples, and groups who want a comfortable road journey with flexible sightseeing stops. Travelers can explore Baga Beach, Calangute Beach, Fort Aguada, Dudhsagar Waterfalls, Panaji, and South Goa attractions while enjoying a relaxed return journey."
  },
  {
    title: "Navi Mumbai to Mahabaleshwar Round Trip",
    description: "Mahabaleshwar is a scenic hill station known for Venna Lake, Arthur's Seat, Mapro Garden, strawberry farms, Elephant's Head Point, and beautiful mountain views. A round trip taxi service allows travelers to explore multiple viewpoints and nearby attractions without worrying about return transportation. It is a perfect choice for family holidays, honeymoon trips, and weekend escapes from Navi Mumbai."
  },
  {
    title: "Navi Mumbai to Shirdi Round Trip",
    description: "Shirdi is a famous pilgrimage destination visited by millions of Sai Baba devotees every year. Travelers can visit Sai Baba Samadhi Temple, Dwarkamai, Chavadi, Gurusthan, and Lendi Baug during their spiritual journey. Round trip cab booking from Navi Mumbai provides comfortable travel for families, senior citizens, and groups with convenient pickup and return drop facilities."
  },
  {
    title: "Navi Mumbai to Lonavala Round Trip",
    description: "Lonavala is a popular weekend getaway famous for Tiger Point, Bhushi Dam, Pawna Lake, Rajmachi Fort, Karla Caves, and Della Adventure Park. The destination is perfect for short vacations, corporate outings, and family trips. A round trip cab offers flexibility to visit multiple attractions while enjoying a comfortable journey through scenic mountain routes."
  },
  {
    title: "Navi Mumbai to Nashik Round Trip",
    description: "Nashik is known for Trimbakeshwar Jyotirlinga, Panchavati, Sula Vineyards, Ramkund, Pandavleni Caves, and religious attractions. A round trip taxi is suitable for pilgrimage tours, wine tourism, business visits, and family travel. Travelers can comfortably explore Nashik city and nearby destinations with a dedicated cab throughout the journey."
  },
  {
    title: "Navi Mumbai to Kolhapur Round Trip",
    description: "Kolhapur is a historic city famous for Mahalaxmi Temple, Panhala Fort, Rankala Lake, Jyotiba Temple, and traditional Maharashtrian culture. A round trip cab service makes it easier for devotees and tourists to visit multiple attractions without changing vehicles. It is a convenient travel option for families and groups planning a comfortable Maharashtra tour."
  },
  {
    title: "Navi Mumbai to Alibaug Round Trip",
    description: "Alibaug is a beautiful coastal destination offering beaches, Kolaba Fort, Varsoli Beach, water sports, seafood, and peaceful resorts. It is one of the most preferred weekend destinations near Navi Mumbai. Round trip cab booking provides hassle-free transportation for travelers planning a relaxing beach holiday with flexible return timing."
  },
  {
    title: "Navi Mumbai to Ratnagiri Round Trip",
    description: "Ratnagiri is a scenic Konkan destination known for Ganpatipule Temple, Ratnadurg Fort, Aare Ware Beach, Thiba Palace, and Alphonso mango orchards. Travelers enjoy coastal landscapes, temples, beaches, and local culture. A round trip cab ensures a comfortable long-distance journey with enough space for passengers and luggage."
  },
  {
    title: "Navi Mumbai to Aurangabad Round Trip",
    description: "Aurangabad is famous for UNESCO World Heritage attractions like Ajanta Caves and Ellora Caves along with Grishneshwar Jyotirlinga, Daulatabad Fort, and Bibi Ka Maqbara. A round trip taxi service allows travelers to explore historical and religious destinations conveniently with a dedicated vehicle throughout the tour."
  },
  {
    title: "Navi Mumbai to Bhandardara Round Trip",
    description: "Bhandardara is a peaceful hill destination known for Arthur Lake, Randha Waterfall, Wilson Dam, camping spots, and beautiful Sahyadri landscapes. It is an ideal location for nature lovers, photographers, and families looking for a relaxing getaway. Round trip cab service provides a comfortable travel experience with convenient pickup and return options."
  }
],


"services": [
  {
    "name": "Round Trip Cab Navi Mumbai",
    "description": "Book Round Trip Cab Navi Mumbai for comfortable and convenient return journeys with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Hyundai Aura, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury cars for family trips, business travel, sightseeing, and outstation return journeys."
  },
  {
    "name": "Navi Mumbai Round Trip Taxi",
    "description": "Reserve Navi Mumbai Round Trip Taxi for safe and reliable travel with experienced drivers, clean vehicles, and flexible booking options. Enjoy hassle-free pickup and return services for local travel, airport transfers, corporate visits, and long-distance destinations."
  },
  {
    "name": "Round Trip Taxi Service in Navi Mumbai",
    "description": "Choose Round Trip Taxi Service in Navi Mumbai for affordable and comfortable two-way transportation with professional chauffeurs. Get reliable cabs for family vacations, business meetings, city tours, and outstation journeys with convenient return scheduling."
  },
  {
    "name": "Round Trip Cab Service Navi Mumbai",
    "description": "Book Round Trip Cab Service Navi Mumbai for dependable travel solutions with premium AC vehicles and experienced drivers. Enjoy smooth pickup, waiting time flexibility, and comfortable return trips from Navi Mumbai to any destination."
  },
  {
    "name": "Book Round Trip Cab Navi Mumbai",
    "description": "Book Round Trip Cab Navi Mumbai online with quick confirmation, transparent pricing, and multiple vehicle choices. Get convenient chauffeur-driven cab services for local, airport, corporate, family, and outstation round trips."
  },
  {
    "name": "Private Round Trip Taxi Navi Mumbai",
    "description": "Hire Private Round Trip Taxi Navi Mumbai for personalized travel with dedicated vehicles and professional drivers. Enjoy privacy, comfort, flexible timings, and smooth return journeys for personal and business requirements."
  },
  {
    "name": "Best Round Trip Cab Service in Navi Mumbai",
    "description": "Choose Best Round Trip Cab Service in Navi Mumbai for safe, comfortable, and reliable transportation. Our chauffeur-driven cabs provide clean interiors, experienced drivers, and quality travel solutions for every round trip requirement."
  },
  {
    "name": "Affordable Round Trip Cab Navi Mumbai",
    "description": "Book Affordable Round Trip Cab Navi Mumbai with budget-friendly fares and premium travel comfort. Select from various car categories with transparent charges, professional drivers, and reliable service for short and long-distance trips."
  },
  {
    "name": "Reliable Round Trip Taxi Navi Mumbai",
    "description": "Choose Reliable Round Trip Taxi Navi Mumbai for punctual pickup, safe driving, and comfortable return travel. Enjoy well-maintained vehicles with experienced chauffeurs for family trips, airport transfers, and corporate transportation."
  },
  {
    "name": "Round Trip Cab Navi Mumbai Fare",
    "description": "Get Round Trip Cab Navi Mumbai Fare with transparent pricing and affordable travel packages. Compare vehicle options including Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cars according to your journey requirements."
  },
  {
    "name": "Navi Mumbai Round Trip Taxi Charges",
    "description": "Check Navi Mumbai Round Trip Taxi Charges with competitive rates and no hidden costs. Enjoy comfortable return journeys with professional drivers, flexible packages, and reliable chauffeur-driven transportation services."
  },
  {
    "name": "Cheapest Round Trip Cab in Navi Mumbai",
    "description": "Book Cheapest Round Trip Cab in Navi Mumbai for economical travel without compromising comfort and safety. Get affordable cab options with clean AC vehicles, experienced chauffeurs, and reliable round trip services."
  },
  {
    "name": "Round Trip Cab Booking Navi Mumbai",
    "description": "Complete Round Trip Cab Booking Navi Mumbai easily with instant confirmation and multiple vehicle choices. Enjoy convenient reservations for family travel, business trips, airport transfers, sightseeing, and outstation journeys."
  },
  {
    "name": "Navi Mumbai Round Trip Cab Price",
    "description": "Get Navi Mumbai Round Trip Cab Price with affordable packages and flexible travel options. Choose suitable vehicles based on passengers, luggage, destination, and trip duration for a comfortable return journey."
  },
  {
    "name": "One Day Round Trip Cab Navi Mumbai",
    "description": "Book One Day Round Trip Cab Navi Mumbai for same-day travel, sightseeing, meetings, and personal visits. Enjoy complete day rental services with professional drivers, comfortable vehicles, and flexible schedules."
  },
  {
    "name": "Same Day Return Cab Navi Mumbai",
    "description": "Reserve Same Day Return Cab Navi Mumbai for convenient travel with pickup and drop facilities on the same day. Perfect for business visits, family functions, shopping trips, and nearby outstation destinations."
  },
  {
    "name": "Family Round Trip Cab Navi Mumbai",
    "description": "Choose Family Round Trip Cab Navi Mumbai for safe and comfortable journeys with spacious vehicles and experienced chauffeurs. Travel conveniently with family-friendly cabs suitable for vacations, temple visits, and weekend trips."
  },
  {
    "name": "Corporate Round Trip Taxi Navi Mumbai",
    "description": "Book Corporate Round Trip Taxi Navi Mumbai for professional business transportation with punctual service and premium vehicles. Ideal for meetings, employee travel, client visits, conferences, and corporate events."
  },
  {
    "name": "Doorstep Pickup Round Trip Cab Navi Mumbai",
    "description": "Hire Doorstep Pickup Round Trip Cab Navi Mumbai for convenient travel from your location with timely pickup and comfortable return service. Enjoy hassle-free journeys with verified drivers and well-maintained AC cars."
  }
],
"tableData": [
  ["Round Trip Cab Navi Mumbai", "Navi Mumbai Round Trip Taxi"],
  ["Round Trip Taxi Service in Navi Mumbai", "Round Trip Cab Service Navi Mumbai"],
  ["Book Round Trip Cab Navi Mumbai", "Private Round Trip Taxi Navi Mumbai"],
  ["Best Round Trip Cab Service in Navi Mumbai", "Affordable Round Trip Cab Navi Mumbai"],
  ["Reliable Round Trip Taxi Navi Mumbai", "Round Trip Cab Navi Mumbai Fare"],
  ["Navi Mumbai Round Trip Taxi Charges", "Cheapest Round Trip Cab in Navi Mumbai"],
  ["Round Trip Cab Booking Navi Mumbai", "Navi Mumbai Round Trip Cab Price"],
  ["One Day Round Trip Cab Navi Mumbai", "Same Day Return Cab Navi Mumbai"],
  ["Family Round Trip Cab Navi Mumbai", "Corporate Round Trip Taxi Navi Mumbai"],
  ["Doorstep Pickup Round Trip Cab Navi Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Round Trip Cab Service in Navi Mumbai",
    WhyChoosedescription: "Shreesha Travels offers convenient round trip cab services in Navi Mumbai for local travel, outstation journeys, family trips, business visits, and weekend getaways. Enjoy a comfortable return journey with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Flexible Return Travel Plans",
    WhyChoosedescription: "Plan your complete journey with pickup and return service from Navi Mumbai. Choose your travel dates, destinations, waiting duration, and return schedule according to your convenience."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Select from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on your passenger count and comfort requirements."
  },
  {
    WhyChooseheading: "Perfect for Outstation & Weekend Trips",
    WhyChoosedescription: "Our round trip cabs are ideal for destinations like Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Kolhapur, Gujarat, Rajasthan, and other popular travel locations."
  },
  {
    WhyChooseheading: "Cost-Effective Travel Solution",
    WhyChoosedescription: "Round trip bookings provide a convenient option for travellers who need return transportation, allowing better planning and comfortable travel without arranging separate vehicles."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Our professional chauffeurs have knowledge of highways, city routes, and popular destinations, ensuring safe driving, punctual service, and a smooth travel experience."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide passengers with a safe and relaxing journey."
  },
  {
    WhyChooseheading: "Book Round Trip Cab in Navi Mumbai with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, quick booking assistance, flexible packages, and reliable chauffeur-driven cabs for your round trip travel requirements from Navi Mumbai."
  }
]

};

const faqData = [
  {
    question: "What is a round trip cab service in Navi Mumbai?",
    answer: "A round trip cab service includes pickup from Navi Mumbai, travel to your destination, waiting as required, and return drop back to Navi Mumbai."
  },
  {
    question: "Can I book a round trip cab for outstation travel?",
    answer: "Yes, round trip cabs are available for destinations across Maharashtra and other states."
  },
  {
    question: "Which vehicles are available for round trip booking?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is round trip cab service suitable for family vacations?",
    answer: "Yes, round trip taxis are a convenient option for families, senior citizens, and groups planning holidays and sightseeing trips."
  },
  {
    question: "Can I book a round trip cab for airport travel?",
    answer: "Yes, round trip airport transfers can be arranged from Navi Mumbai to airports and return journeys."
  },
  {
    question: "Can I customize my round trip travel plan?",
    answer: "Yes, you can customize destinations, sightseeing stops, waiting time, travel dates, and vehicle selection according to your requirements."
  },
  {
    question: "How is the round trip cab fare calculated?",
    answer: "The fare depends on the vehicle type, total distance, number of travel days, route, toll charges, parking fees, and waiting requirements."
  },
  {
    question: "Are round trip cabs available for pilgrimage tours?",
    answer: "Yes, round trip cab services are available for destinations like Shirdi, Trimbakeshwar, Ashtavinayak temples, Jyotirlinga tours, and other religious places."
  },
  {
    question: "Can I book a round trip cab for corporate travel?",
    answer: "Yes, round trip transportation is available for business meetings, corporate visits, factory tours, and official travel."
  },
  {
    question: "How can I book Round Trip Cab Navi Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a customized quotation and confirm your round trip cab booking."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Mehta",
    feedback: "We booked a round trip cab from Navi Mumbai for our family vacation. The vehicle was comfortable, the driver was professional, and the complete journey was well managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Joshi",
    feedback: "Excellent round trip cab service. The booking process was easy, pricing was clear, and the chauffeur provided a safe and comfortable travel experience.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Round Trip Cab Navi Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/round-trip-cab-navi-mumbai.webp",
  "description":
    "Book Round Trip Cab Navi Mumbai with Shreesha Tours & Travels for comfortable and reliable taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for round-trip journeys, family vacations, business travel, sightseeing tours, outstation trips, and long-distance travel from Navi Mumbai with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/round-trip-cab-navi-mumbai"
  }
};




    return (
        <div>
<Helmet>
  <title>Round Trip Cab Navi Mumbai | Round Trip Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Round Trip Cab Navi Mumbai with Shreesha Travels for safe and comfortable round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for family trips, sightseeing tours, outstation travel, business journeys, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Round Trip Cab Navi Mumbai, Navi Mumbai Round Trip Taxi, Round Trip Taxi Service in Navi Mumbai, Round Trip Cab Service Navi Mumbai, Book Round Trip Cab Navi Mumbai, Private Round Trip Taxi Navi Mumbai, Best Round Trip Cab Service in Navi Mumbai, Affordable Round Trip Cab Navi Mumbai, Reliable Round Trip Taxi Navi Mumbai, Outstation Round Trip Cab Navi Mumbai, Navi Mumbai Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Roundtripcabnavimumbai;